import axios from '@/axios'
import * as types from '../../mutation-types'

export default {
    namespaced: true,

    state: {
        deductions: []
    },

    actions: {
        fetchAll({ commit }) {
            return axios.get('/salaries/deduction').then(({ data }) => {
                commit(types.STORE_DEDUCTIONS, data);
                return data;
            })
        },

        create({ commit }, { name, pattern, isRate, value }) {
            return axios.post('/salaries/deduction', { name, pattern, isRate, value });
        },

        update({ commit }, { id, name, pattern, isRate, value }) {
            return axios.put(`/salaries/deduction/${id}`, { name, pattern, isRate, value });
        },
    },

    mutations: {
        [types.STORE_DEDUCTIONS](state, deductions) {
            state.deductions = deductions;
        }
    },

    getters: {
        getDeductionById: state => id => state.deductions.find(c => c.id === id)
    }
}